module.exports = __webpack_public_path__ + "media/images/methods_continuum-5c892229333dc41cb9154b6894dee608.png";